(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-banner"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('kc-hero-film')){customElements.define('kc-hero-film',class extends HTMLElement{connectedCallback(){this.video=this.querySelector('video');this.button=this.querySelector('button');if(!this.video||!this.button||this.abort)return;this.abort=new AbortController();const options={signal:this.abort.signal};this.motion=window.matchMedia('(prefers-reduced-motion: reduce)');this.userPaused=this.motion.matches||Boolean(navigator.connection&&navigator.connection.saveData);this.visible=true;const update=()=>{this.button.setAttribute('aria-label',this.video.paused?this.button.dataset.play:this.button.dataset.pause);this.button.querySelector('span').textContent=this.video.paused?'▶':'Ⅱ'};this.play=()=>{if(!this.video.src)this.video.src=this.video.dataset.src;this.video.muted=true;this.video.defaultPlaybackRate=0.65;this.video.playbackRate=0.65;this.video.play().catch(update)};this.button.hidden=false;this.button.addEventListener('click',()=>{this.userPaused=!this.video.paused;if(this.userPaused)this.video.pause();else this.play()},options);this.video.addEventListener('playing',()=>{this.video.setAttribute('data-ready','');update()},options);this.video.addEventListener('pause',update,options);this.video.addEventListener('error',()=>{this.video.removeAttribute('data-ready');this.button.hidden=true},options);this.motion.addEventListener('change',()=>{this.userPaused=this.motion.matches;if(this.userPaused){this.video.pause();this.video.removeAttribute('data-ready')}else if(this.visible&&!document.hidden)this.play()},options);document.addEventListener('visibilitychange',()=>{if(document.hidden)this.video.pause();else if(this.visible&&!this.userPaused)this.play()},options);this.observer=new IntersectionObserver(([entry])=>{this.visible=entry.isIntersecting;if(!this.visible)this.video.pause();else if(!this.userPaused&&!document.hidden)this.play()},{threshold:0.05});this.observer.observe(this)}disconnectedCallback(){if(this.video)this.video.pause();if(this.observer)this.observer.disconnect();if(this.abort)this.abort.abort();this.abort=null}})}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kc-plans"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('kc-plan-photos'))customElements.define('kc-plan-photos',class extends HTMLElement{connectedCallback(){this.slides=[...this.querySelectorAll('.kc-plan__slide')];if(this.slides.length<2||this.timer)return;this.index=0;this.button=this.querySelector('button');this.button.hidden=false;this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.paused=this.motion.matches;this.abort=new AbortController();const opts={signal:this.abort.signal};this.update=()=>{this.button.textContent=this.paused?'▶':'Ⅱ';this.button.setAttribute('aria-label',this.paused?this.button.dataset.play:this.button.dataset.pause)};this.button.addEventListener('click',()=>{this.paused=!this.paused;this.update()},opts);this.motion.addEventListener('change',()=>{this.paused=this.motion.matches;this.update()},opts);this.visible=false;this.observer=new IntersectionObserver(([e])=>this.visible=e.isIntersecting);this.observer.observe(this);this.timer=setInterval(()=>{if(this.paused||!this.visible||document.hidden||this.contains(document.activeElement))return;this.slides[this.index].classList.remove('is-active');this.slides[this.index].setAttribute('aria-hidden','true');this.index=(this.index+1)%this.slides.length;this.slides[this.index].classList.add('is-active');this.slides[this.index].removeAttribute('aria-hidden')},4000);this.update()}disconnectedCallback(){clearInterval(this.timer);this.timer=null;this.observer?.disconnect();this.abort?.abort()}});

  } catch(e) { console.error(e); }
})();
})();
